import axios from 'axios';
import type { AxiosError, AxiosResponse } from 'axios';

const retryOrHandleError = async (error: AxiosError): Promise<AxiosResponse> => {
  const { config, response } = error;

  if (response?.status === 500 && config) {
    const result = await axios(config);

    return result;
  }

  throw error;
};

export default retryOrHandleError;
